import {FC, useEffect} from "react";
import Checkers from "../../../../helpers/class/Checkers";

interface SImpleContentPros {
    content: string
    extraContent?: string
}
const SimpleContent: FC<SImpleContentPros> = ({content, extraContent = ''} ) => {

    return (
        <>
            {
                Checkers.isHtml(content) ?
                    <>
                        <div className={'m-t-20 m-b-20'} dangerouslySetInnerHTML={{ __html: content }} />
                    </>
                    :
                    <>
                        <div className={'m-t-20 m-b-20'}>
                            <p>{content}</p>
                        </div>
                    </>
            }
            <div className={'m-t-20 m-b-20'} dangerouslySetInnerHTML={{ __html: extraContent }} />
        </>
    )
}

export default SimpleContent